/** @fileoverview Empty / error states of the student tracker. */

import { Box, Button, Stack, Text } from '@mantine/core'
import { IconArticleOff } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

export type StudentTrackerEmptyVariant = 'select_project' | 'no_tasks' | 'not_enrolled' | 'error'

interface StudentTrackerEmptyStateProps {
  variant: StudentTrackerEmptyVariant
  onRetry?: () => void
}

const ICON_SIZE = 24
const ICON_STROKE = 1.8
const CONTAINER_STYLE = {
  border: '1px dashed var(--mantine-color-gray-5, #adb5bd)',
  borderRadius: 12,
  backgroundColor: 'var(--mantine-color-gray-1, #f8f9fa)',
}

export function StudentTrackerEmptyState({ variant, onRetry }: StudentTrackerEmptyStateProps) {
  const { t } = useTranslation()

  return (
    <Box p='xl' style={CONTAINER_STYLE}>
      <Stack align='center' spacing={8}>
        <IconArticleOff size={ICON_SIZE} color='#868e96' stroke={ICON_STROKE} />
        <Text weight={600} align='center' size='md'>
          {t(`student_task_tracker.empty.${variant}_title`)}
        </Text>
        <Text color='dimmed' align='center' size='md'>
          {t(`student_task_tracker.empty.${variant}_description`)}
        </Text>
        {variant === 'error' && onRetry && (
          <Button variant='light' size='xs' mt='xs' onClick={onRetry}>
            {t('student_task_tracker.empty.retry')}
          </Button>
        )}
      </Stack>
    </Box>
  )
}
